import React, { useEffect, useState } from 'react';
import VarRevInsDetailPresentational from './VarRevInsDetailPresentational';
import { useLoading } from '../../../../commons/Loading';
import { useAuth } from '../../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import {
  createBonus,
  createBonusCommercial,
  getReportsVariableRevenuesInsurances,
  getReportsVariableRevenuesInsurancesNetwork,
} from '../../../../lib/fetch/reports';
import { useDebouncedCallback } from 'use-debounce';
import { useAlert } from 'react-alert';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const VarRevInsDetail = (props) => {
  const { profile = {} } = props;
  const { _id: profileId } = profile;
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation('CONTACTS');
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(NumberParam, new Date().getFullYear()),
    insuranceStartMonth: NumberParam,
    policy_code: withDefault(StringParam, ''),
    admin_cf: withDefault(StringParam, ''),
    supplier: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    customerType: withDefault(StringParam, ''),
    active: withDefault(StringParam, ''),
    agencyType: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    year,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    supplier,
    customer,
    customerType,
    active,
    agencyType,
  } = query;

  const [fetchReportsInsurances] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getReportsVariableRevenuesInsurancesNetwork({
      limit,
      offset,
      year,
      insuranceStartMonth,
      policy_code,
      admin_cf,
      supplier,
      customer,
      customerType,
      active,
      newToken,
      profileId,
      agencyType,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenuesInsurances?.count);
  }, 1000);

  function onFilter(queryDiff) {
    if (
      (queryDiff.insuranceStartMonth &&
        queryDiff.insuranceStartMonth !== insuranceStartMonth) || // first search
      (insuranceStartMonth && queryDiff.insuranceStartMonth === '') || // search deleted
      (queryDiff.policy_code && queryDiff.policy_code !== policy_code) || // first search
      (policy_code && queryDiff.policy_code === '') || // search deleted
      (queryDiff.agencyType && queryDiff.agencyType !== agencyType) || // first search
      (agencyType && queryDiff.agencyType === '') || // search deleted
      (queryDiff.admin_cf && queryDiff.admin_cf !== admin_cf) || // first search
      (admin_cf && queryDiff.admin_cf === '') || // search deleted
      (queryDiff.supplier && queryDiff.supplier !== supplier) || // first search
      (supplier && queryDiff.supplier === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.customerType && queryDiff.customerType !== customerType) || // first search
      (customerType && queryDiff.customerType === '') || // search deleted
      (queryDiff.active && queryDiff.active !== active) || // first search
      (active && queryDiff.active === '') || // search deleted
      (queryDiff.year && queryDiff.year !== year) || // first search
      (year && queryDiff.year === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  useEffect(() => {
    fetchReportsInsurances();
  }, [
    limit,
    offset,
    year,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    supplier,
    customer,
    customerType,
    active,
    agencyType,
  ]);

  async function onAddCommercialBonus(bonus) {
    const { error } = await createBonusCommercial({
      newToken,
      bonus: { ...bonus, profileId },
      year,
    });

    if (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    fetchReportsInsurances();
    alert.success(t('COMMON:SUCCESS_CREATE'));
  }

  return (
    <VarRevInsDetailPresentational
      data={reports}
      onAddCommercialBonus={onAddCommercialBonus}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      {...props}
    />
  );
};

export default VarRevInsDetail;
